<template>
    <div>
        <b-card class="bg-t-dark-- m-1 notifications-card">
            <template #header>
                <b-col>
                    <h5>
                        <b-icon-bell/>
                        &nbsp;
                        {{$t("Notifications / Pendencies")}}
                    </h5>
                </b-col>
            </template>
            <b-row>
                <b-col>
                    <b-icon-circle-fill class="text-danger"/>
                    Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ratione, voluptatum. Delectus incidunt est
                </b-col>
            </b-row>
            <hr>
            <b-row>
                <b-col>
                    Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ratione, voluptatum. Delectus incidunt est
                </b-col>
            </b-row>
            <hr>
            <b-row>
                <b-col>
                    Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ratione, voluptatum. Delectus incidunt est
                </b-col>
            </b-row>
            <hr>
            <b-row>
                <b-col>
                    Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ratione, voluptatum. Delectus incidunt est
                </b-col>
            </b-row>
            <hr>
            <b-row>
                <b-col>
                    <b-icon-circle-fill class="text-danger"/>
                    Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ratione, voluptatum. Delectus incidunt est
                </b-col>
            </b-row>
            <hr>
            <b-row>
                <b-col>
                    <b-icon-circle-fill class="text-danger"/>
                    Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ratione, voluptatum. Delectus incidunt est
                </b-col>
            </b-row>
            <hr>
            <b-row>
                <b-col>
                    <b-icon-circle-fill class="text-danger"/>
                    Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ratione, voluptatum. Delectus incidunt est
                </b-col>
            </b-row>
            <hr>
            <b-row>
                <b-col>
                    <b-icon-circle-fill class="text-danger"/>
                    Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ratione, voluptatum. Delectus incidunt est
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>